import { ROLES } from "shared/config";
import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

const defaultValue = {
  role: ROLES.USER,
  advancePaymentsQueue: false,
};

export const useRequestPersistedStore = create()(
  persist(
    devtools((set) => ({
      viewRequestAs: defaultValue,
      setViewRequestAs: (payload) => {
        set({ viewRequestAs: { ...defaultValue, ...payload } });
      },
    })),
    {
      name: "view-request-store",
    }
  )
);
